import React, { useEffect, useCallback, useState, useRef } from 'react';
import { MdRestaurant, MdLocalBar } from 'react-icons/md';
import { FormHandles } from '@unform/core';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import Input from '../../Inputs/Input';

import {
  Container,
  Content,
  Header,
  ContentBody,
  CategoriaList,
  CategoriaItem,
  CadastroCategoria,
  CategoriaSelected,
  FormView,
  Buttons,
} from './styles';

type ClassificacaoData = {
  id: number;
  id_sub: number;
  nome: string;
  prod_visible: boolean;
  status: string;
}
type CategoriaData = {
  CODCLA: number;
  NOMCLA: string;
}
interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	classificacao?: ClassificacaoData;
}

const ModalClassificacao: React.FC<ModalParams> = ({
  id = 'ModalClassificacao',
  onClose = () => {},
  isVisible,
  classificacao,
}) => {
  const handleOutSideClick = useCallback(
		(e: any) => {
      if (e.target.id === id) {
        setVisible(!isVisible);
        setTimeout(() => {
          onClose();
        }, 100);
      }
    },
    [id, onClose, isVisible],
  );

  const formRef = useRef<FormHandles>(null);
  const { company } = useAuth();

  const [visible, setVisible] = useState(isVisible);
  const [categorias, setCategorias] = useState<CategoriaData[]>([]);
  const [categoria, setCategoria] = useState<CategoriaData>(
    {} as CategoriaData,
  );

  const [classDisabled, setClassDisabled] = useState(true);

  useEffect(() => {
    api.get(`portal/classif`).then(response => {
      setCategorias(response.data);

      if (classificacao?.id) {
        const index = response.data.findIndex(
          (item: CategoriaData) => item.CODCLA === classificacao.id,
        );

        setCategoria(response.data[index]);
      }
    });
  }, [company.id, classificacao]);

  const handleDisabled = useCallback(() => {
    const teste = formRef.current?.getFieldValue('nome');

    if (classificacao?.id) {
      if (teste !== classificacao.nome) {
        setClassDisabled(false);
      } else {
        setClassDisabled(true);
      }
    } else if (
      !teste ||
      teste === null ||
      teste === undefined ||
      teste === ''
    ) {
      setClassDisabled(true);
    } else {
      setClassDisabled(false);
    }
  }, [classificacao]);

  return (
    <Container id="ModalClassificacao" onClick={handleOutSideClick}>
      <Content className={`${visible && 'active'}`}>
        <Header>
          <h1>Nova Classificação</h1>

          <h3>
            {categoria.CODCLA
              ? 'Detalhes da Classificação'
              : 'Selecione um modelo de Categoria para dividir seu cardápio'}
          </h3>
        </Header>

        <ContentBody>
          {!categoria.CODCLA && (
            <CategoriaList>
              {categorias.map((cat, indice) => (
                <CategoriaItem key={indice} onClick={() => setCategoria(cat)}>
                  <div className="category-icon">
                    {cat.CODCLA === 1 ? <MdRestaurant /> : <MdLocalBar />}
                  </div>

                  <div className="category-description">
                    <h1>{cat.NOMCLA}</h1>
                    {cat.CODCLA === 1 ? (
                      <span>pratos, lanches, sobremesas, etc.</span>
                    ) : (
                      <span>agua, refrigerante, cerveja, vinho, etc.</span>
                    )}
                  </div>
                </CategoriaItem>
              ))}
            </CategoriaList>
          )}

          {categoria.CODCLA && (
            <CadastroCategoria>
              <h1>Modelo</h1>

              <CategoriaSelected>
                <div className="category-data">
                  <div className="category-icon">
                    {categoria.CODCLA === 1 ? <MdRestaurant /> : <MdLocalBar />}
                  </div>

                  <div className="category-description">
                    <h1>{categoria.NOMCLA}</h1>
                  </div>
                </div>

                <div className="category-button">
                  <button onClick={() => setCategoria({} as CategoriaData)}>
                    Alterar
                  </button>
                </div>
              </CategoriaSelected>

              <FormView
                ref={formRef}
                initialData={classificacao}
                onSubmit={() => {}}
              >
                <h1>Nome da Categoria</h1>
                <Input
                  name="nome"
                  type="text"
                  onChange={handleDisabled}
                  placeholder="Exemplo: Carro chefe, pratos, lanches, sobremesas"
                />
              </FormView>

              <Buttons>
                <button className="button-cancel" onClick={onClose}>
                  Cancelar
                </button>
                <button className="button-save" disabled={classDisabled}>
                  Salvar
                </button>
              </Buttons>
            </CadastroCategoria>
          )}
        </ContentBody>
      </Content>
    </Container>
  );
};

export default ModalClassificacao;
